import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { getPrevStep, getNextStep, StepDefinition } from '../../helpers/Steps';
import { useCurrentApplication } from './useCurrentApplication';
import { useCurrentUserInfo } from './useCurrentUserInfo';

export const useApplicationSteps = (): {
  prevStep: StepDefinition | null;
  nextStep: StepDefinition | null;
} => {
  const intl = useIntl();
  const location = useLocation();
  const { application } = useCurrentApplication();
  const {
    userInfo: { isExternal },
  } = useCurrentUserInfo();

  const steps = useMemo(() => {
    const appType = application.result?.applicationType;
    if (!appType) return { nextStep: null, prevStep: null };
    return {
      prevStep: getPrevStep(location.pathname, appType, intl, isExternal),
      nextStep: getNextStep(location.pathname, appType, intl, isExternal),
    };
  }, [application.result?.applicationType, location.pathname]);

  return steps;
};
